import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Download } from 'styled-icons/boxicons-regular';
import { palette } from '../../../system/styles/styles';

const VacancyDetailModal = ({ apps, open, close, className }) => {
  const [data, setData] = React.useState([]);

  const loadingCell = (tdElement, others) => {
    const { dataItem, field } = others;

    if (field === 'cv') {
      return (
        <td>
          <a href={dataItem.cv} target="_blank" rel="noopener noreferrer" className="download">
            Descargar <Download size={20} color="white" />
          </a>
        </td>
      );
    }

    return tdElement;
  };

  React.useEffect(() => {
    const data = (apps.docs || []).map((doc) => {
      const temp = doc.data();
      return {
        names: `${temp.names  } ${  temp.lastNames}`,
        career: temp.career,
        email: temp.email,
        cv: temp.cv,
      };
    });
    setData(data);
  }, [apps]);

  if (!open) return null;

  return (
    <Dialog onClose={close} title="Alumnos que postularon a está vacante">
      <div className={className}>
        <div>
          <p className="mc-name">{`Se entrontraron ${apps.size} resultados para esta vacante`}</p>
          <div className="vdm-list-container">
            <Grid
              style={{
                height: '100%',
              }}
              data={data}
              cellRender={loadingCell}>
              <Column field="names" title="Nombre" />
              <Column field="career" title="Carrera" />
              <Column field="email" title="Email" />
              <Column field="cv" title="CV" />
            </Grid>
          </div>
          {apps.empty ? <p className="mc-message"> Nadie se ha postulado a esta vacante aún. </p> : null}
        </div>
      </div>
    </Dialog>
  );
};

export default styled(VacancyDetailModal)`
  position: relative;
  margin: 10px auto;
  background-color: white;
  box-shadow: ${palette.lightBS};
  padding: 16px;
  outline: none;
  font-family: 'Sofia Pro', sans-serif;
  max-width: 768px;
  max-height: 90vh;
  font-size: 1.7rem;
  p {
    font-size: 16px;
    margin: 12px 0;
  }
  .download {
    width: auto;
    padding: 7px 17px;
    background-color: #5373fc;
    color: ${palette.white};
    font-size: 1.6rem;
    font-weight: 500;
    border-radius: 4px;
    text-decoration: none;
    font-family: 'Sofia Pro', sans-serif;
    &:hover {
      color: ${palette.white};
    }
  }
`;
